//
//
//
//
//
//
//
//
//
//
//
//
//
//
import codeedit from "../../page/bigScreen/group/code";
export default {
  inject: ["main"],
  data: function data() {
    return {
      code: {
        box: false,
        obj: {}
      }
    };
  },
  components: {
    codeedit: codeedit
  },
  methods: {
    codeClose: function codeClose(value) {
      this.main.activeObj[this.code.type] = value;
    },
    openCode: function openCode() {
      this.code.type = 'echartFormatter';
      this.code.obj = this.main.activeObj[this.code.type];
      this.code.box = true;
    }
  }
};